import type { Conference } from '../types/content';

export const conferences: Conference[] = [
  { name: 'StreamTV', detail: 'Global Streaming & OTT Summit' },
  { name: 'NEM Dubrovnik', detail: 'New Europe Market Conference' },
  { name: 'MIPCOM', detail: 'International Content Market' }
];
